(() => {
  const controllerKey = '__saPdpBenefitsKlaviyoController';
  const triggerSelector = '[data-sa-pdp-benefits-klaviyo-trigger]';

  if (window[controllerKey]) return;
  window[controllerKey] = true;

  document.addEventListener(
    'click',
    (event) => {
      const eventTarget = event.target;
      if (!(eventTarget instanceof Element)) return;

      const trigger = eventTarget.closest(triggerSelector);
      if (!trigger || !trigger.closest('sa-pdp-benefits')) return;

      const formId = trigger.dataset.klaviyoFormId?.trim();
      if (!formId) return;

      event.preventDefault();
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', formId]);
    },
    true
  );
})();
